import * as actionTypes from 'constants/ActionTypes';

export function getVesselSales(filter) {
    return {
        type: actionTypes.GET_VESSEL_SALES.REQUEST,
        filter,
    };
}

export function createVesselSales(items) {
    return {
        type: actionTypes.CREATE_VESSEL_SALES,
        items,
    };
}

export function updateVesselSale(numberSale, newVesselSale) {
    return {
        type: actionTypes.UPDATE_VESSEL_SALE,
        numberSale,
        newVesselSale,
    };
}

export function addVesselSale() {
    return {
        type: actionTypes.ADD_VESSEL_SALE,
    };
}

export function removeLastVesselSale() {
    return {
        type: actionTypes.REMOVE_LAST_VESSEL_SALE,
    };
}

export function resetVesselSales() {
    return {
        type: actionTypes.RESET_VESSEL_SALES,
    };
}

export function updateVesselSaleUser(user) {
    return {
        type: actionTypes.UPDATE_VESSEL_SALE_USER,
        user,
    };
}

export function removeAllVesselSales() {
    return {
        type: actionTypes.REMOVE_ALL_VESSEL_SALES,
    };
}

export function postVesselSale(vesselId, vesselSaleRequest) {
    return {
        type: actionTypes.POST_VESSEL_SALE.REQUEST,
        vesselSaleRequest,
        vesselId,
    };
}

export function postVesselSaleResponse(response) {
    if (response.status) {
        return {
            type: actionTypes.POST_VESSEL_SALE.SUCCESS,
            vesselSaleRequest: response.vesselSaleRequest,
            message: response.message,
        };
    }

    return {
        type: actionTypes.POST_VESSEL_SALE.FAILURE,
        vesselSaleRequest: response.vesselSaleRequest,
        error: response.error,
    };
}

export function deleteVesselSale(saleId) {
    return {
        type: actionTypes.DELETE_VESSEL_SALE.REQUEST,
        saleId,
    };
}



// WEBPACK FOOTER //
// ./app/actions/vessels/sales.js